import { useMutation, UseMutationResult } from 'react-query'
import { api } from '../../../api'
import { localConfig } from '../../../../Configs/localConfig'
import { errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'

interface PropsDeleteInoculante {
  cod: number
  microrganismos_remover?: number[]
  setDeuErro: React.Dispatch<React.SetStateAction<string>>
}
interface PropsDeletar {
  cod_inoculante: number
  refetch_deletar: () => void
}

export const usePutRemoverMicrorganismos = (): {
  carregando_remover_microrganismos: boolean
  mutate_remover_microrganismos: (params: PropsDeleteInoculante) => void
  isSuccess_remover_microrganismos: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsDeleteInoculante> = useMutation(
    async (params: PropsDeleteInoculante) => {
      const { cod, microrganismos_remover, setDeuErro } = params

      //  propriedades_remover?.length <= 0 &&  loadingAlert({ msg: 'Removendo...', id: 'remove_ativo' })

      return api
        .put(
          `recomendacao/bioinsumo/${cod}?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }`,
          {
            microrganismos_remover: microrganismos_remover,
          }
        )
        .then((response: any) => {
          successAlert('Microrganismos removido com sucesso!', 5000, 'remover')
          setDeuErro('sucesso')
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao remover microrganismo!', 5000, 'remover')
              errorAlert('Salvar primeiro o produto para poder alterar a composição!')
              setDeuErro('erro')
            })
          } else {
            errorAlert(
              error.response.data.error ?? 'Falha ao remover microrganismo!',
              5000,
              'teste'
            )
            setDeuErro('erro')
          }

          throw error
        })
    }
  )

  return {
    carregando_remover_microrganismos: mutation.isLoading,
    mutate_remover_microrganismos: mutation.mutate,
    isSuccess_remover_microrganismos: mutation.isSuccess,
  }
}

export const useDeletarInoculante = (): {
  carregando_deletar_inoculante: boolean
  mudate_deletar_inoculante: (params: PropsDeletar) => void
} => {
  const mutation: UseMutationResult<Response, Error, PropsDeletar> = useMutation(
    async (params: PropsDeletar) => {
      const { cod_inoculante, refetch_deletar } = params

      const config = localConfig()

      loadingAlert({ msg: 'Excluindo...', id: 'delete_inoculante' })

      return api
        .delete(
          `recomendacao/bioinsumo/${cod_inoculante}?codConta=${config.conta}&codCliente=${config?.codCliente}`
        )
        .then((response: any) => {
          successAlert('Excluído com sucesso!', 5000, 'delete_inoculante')
          refetch_deletar?.()
          return response
        })
        .catch((error: Error) => {
          //@ts-ignore
          let error_response = error?.response?.data
          errorAlert(
            error_response?.error ?? 'Falha ao excluir inoculante',
            5000,
            'delete_inoculante'
          )

          throw error
        })
    }
  )

  return {
    carregando_deletar_inoculante: mutation.isLoading,
    mudate_deletar_inoculante: mutation.mutate,
  }
}
